




























































































import Vue from 'vue'
import Logo from '@/components/Logo.vue'
import { CartType } from '@/store/types'

export default Vue.extend({
  name: 'NavBar',
  components: { Logo },
  computed: {
    getRedirectPath (): any {
      // 設置重新導向，若在首頁、註冊、登入頁面做切換不需設置 redirect，其他頁面則需要重新導向，若已經設置重新導向頁面，則註冊、登入切換時，並不會互相把自己的頁面給放進重新導向內
      const disableRedirectPaths = ['/', '/signup', '/login']
      return disableRedirectPaths.some(disableRedirectPath => this.$route.path === disableRedirectPath) ? (this.$route.query.redirect === undefined ? null : { redirect: this.$route.query.redirect }) : { redirect: this.$route.path }
    },
    activeCategory (): string {
      return this.$store.getters['info/active'].activeCategory
    }
  },
  watch: {
    '$store.getters.isLogin': function (newValue, oldValue) {
      if (oldValue !== newValue) {
        this.initializeCartList()
      }
    },
    '$router.currentRoute.query.category': function (newValue) {
      if (newValue.category === '0') {
        delete this.$router.currentRoute.query.category
      }
    }
  },
  created () {
    this.initializeCategoryList()
    this.initializeCartList()
  },
  methods: {
    async initializeCategoryList () {
      const categoryList = this.$store.getters['info/categoryList']
      try {
        if (categoryList.length === 0) {
          await this.$store.dispatch('info/FETCH_CATEGORY_LIST')
        }
      } catch (error) {
        console.error(error)
      }
    },
    async initializeCartList () {
      try {
        await this.$store.dispatch('GET_CART_LIST', CartType.count)
      } catch (error) {
        console.error(error)
      }
    },
    handleHomepageClick () {
      this.$bvModal.msgBoxConfirm('您即將跳轉至主網站，是否進行跳轉？', {
        footerClass: 'msgbox-ok-footer',
        okTitle: '確定',
        cancelTitle: '取消',
        centered: true
      }).then(
        accepted => {
          if (accepted) { window.open('https://nuphoto.com.tw/', '_blank') }
        })
    },
    async handleLogout () {
      this.$store.commit('RESET')
      this.$store.commit('logger/PUSH_LOG', 'Logout')
      this.$store.commit('RESET_CART')

      this.$bvModal.msgBoxOk('已登出', {
        centered: true,
        footerClass: 'msgbox-ok-footer',
        okTitle: '確定'
      }).then(() => {
        if (this.$route.path !== '/') {
          this.$router.push('/')
        }
      })
    },
    sendCartClickEvent () {
      this.$gtag.event('點選購物車按鈕', {
        event_category: 'UI/UX',
        event_label: 'NavBar'
      })
    },
    onCategoryItemClicked (categoryId: number) {
      this.$store.commit('info/SET_ACTIVE', { activeCategory: categoryId.toString() })
      if (categoryId === 0) {
        if (this.$route.name === 'Home' && (this.$route.query.category === undefined || this.$route.query.category === '0')) {
          this.$emit('loadData')
        }
      } else {
        if ((this.$route.query.category || '').toString() === categoryId.toString()) {
          this.$emit('loadData')
        }
      }
    },
    onLoginClicked () {
      this.$store.commit('info/SET_ACTIVE', { activeCategory: null })
      if (this.$route.name !== 'Login') {
        this.$router.push({ name: 'Login', query: this.getRedirectPath })
      }
    },
    onCartClicked () {
      this.$store.commit('info/SET_ACTIVE', { activeCategory: null })
      if (this.$route.name === 'Login' || this.$route.name === 'SignUp') {
        if (this.$route.query.redirect === '/cart') return
        if (this.$store.getters.isLogin) {
          this.$router.push('/')
        } else {
          this.$router.push(
            { name: 'Login', query: { redirect: '/cart' } }
          )
        }
        return
      }
      this.sendCartClickEvent()
      if (this.$route.name !== 'Cart') {
        this.$router.push({ name: 'Cart' }).catch(() => { /* Do nothing */ })
      } else {
        this.$emit('loadData')
      }
    },
    onOrderClicked () {
      this.$store.commit('info/SET_ACTIVE', { activeCategory: null })
      if (this.$route.name !== 'Order') {
        this.$router.push({ name: 'Order' })
      } else {
        this.$emit('loadData')
      }
    }
  }
})
